import React from "react";
import { motion } from "framer-motion";

function HeadOffice() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-sky-50 to-blue-100 py-12 px-4 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-700 to-indigo-600 mb-12"
        >
          🏢 Head Office – Shine Agri Allied & Marketing Multistate Cooperative Society Ltd
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="bg-white/90 backdrop-blur-lg shadow-2xl rounded-2xl px-8 py-10 border-l-8 border-blue-600"
        >
          <div className="grid md:grid-cols-2 gap-8">
            {/* Left: Office Address */}
            <div className="space-y-5 text-gray-800 text-[16px]">
              <h2 className="text-2xl font-bold text-blue-800">📍 Registered Head Office</h2>
              <p>
                Shine Agri Allied & Marketing Multistate Cooperative Society Ltd.<br />
                48, First Floor, Amar Arcade,<br />
                Village Nilpur, Taluka Dantiwada,<br />
                District Banaskantha, Gujarat – 385505
              </p>
              <p><strong>Area of Operation:</strong> Gujarat & Uttar Pradesh</p>
              <p><strong>Registration No:</strong> MSCS/CR/1572/2024</p>
              <p><strong>Registered On:</strong> 09 December 2024</p>
            </div>

            {/* Right: Updated Google Map */}
            <div className="overflow-hidden rounded-xl border shadow-xl">
              <iframe
                title="Head Office Map"
                src
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default HeadOffice;
